import type { HsVector3 } from '../../math-new/objects/vector3.class';

export abstract class HsCollider {
  public bounciness: number = 1;
  public abstract setCenter(x: number, y: number, z: number): void;
  public abstract getDistance(position: HsVector3): number;
  public abstract getNormal(position: HsVector3, target: HsVector3): HsVector3;
}
